import React from 'react';

export default function Games() {
  return (
    <div>
      <h1>Coming soon!</h1>
    </div>
  );
}
